<script>
import aeBooking from '@/views/cargo/v0/AirExport/aeBooking'

export default {
  name: 'FBAAeBooking',
  extends: aeBooking
}
</script>
